import { Component, OnInit, ChangeDetectorRef, Inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DataPrivacyService } from '@app/data-privacy/data-privacy.service';
import { SkillScaleLevelChangeService } from '@app/profile/components/skill-scale-level-change-modal/services/skill-scale-level-change.service';
import { AuthService } from '@app/shared/services/auth.service';
import { LDFlagsService } from '@app/shared/services/ld-flags.service';
import { WindowToken } from '@app/shared/window.token';

@Component({
  selector: 'dgx-learner-experience-layout',
  templateUrl: './learner-experience-layout.component.html',
  styleUrls: ['./learner-experience-layout.component.scss'],
})
export class LearnerExperienceLayoutComponent implements OnInit {
  private readonly IS_MOBILE = '1';

  public _hideAppHeader: boolean = false;
  public showChannelHeader: boolean = false;
  public showNewLayout: boolean = false;

  public get showAppHeader(): boolean {
    return !this._hideAppHeader && !this.showChannelHeader;
  }
  public get isHostedContent(): boolean {
    return !!this.route.snapshot.queryParams?.hosted;
  }

  public get userHasAcceptedPrivacyPolicy(): boolean {
    // this can be reached in the unauthed view, don't assume that there is an authUser
    return this.authService?.authUser?.hasAcceptedPrivacyPolicy;
  }

  // copied from input-page-wrapper.component.ts
  public get isNativeApp(): boolean {
    return this.route.snapshot.queryParams?.mobile === this.IS_MOBILE;
  }

  constructor(
    @Inject(WindowToken) windowRef: Window,
    private authService: AuthService,
    private route: ActivatedRoute,
    private dataPrivacyService: DataPrivacyService,
    private skillScaleLevelChangeService: SkillScaleLevelChangeService,
    private ldFlagsService: LDFlagsService
  ) {
    this._hideAppHeader =
      windowRef['__GLOBALS__'].hideAppHeader ||
      this.isNativeApp ||
      this.route.snapshot.children[0].data['hideAppHeader'];
    this.showNewLayout = this.ldFlagsService.lxpLayoutRefresh;
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.showChannelHeader = params.context === 'channel';
    });

    // Require user to accept privacy policy if org requires it
    this.dataPrivacyService.getDataPrivacyModal();
    // Notify user of skill scale level change if org requires it
    this.skillScaleLevelChangeService.getSkillScaleLevelChangeModal();
  }
}
